import { AlertTriangle, Users, Clock, TrendingUp, Brain } from 'lucide-react';

const StaffingCrisis = () => {
  const crisisStats = [
    { stat: '50+', label: 'Average age of federal 1102s', icon: Users },
    { stat: '30%', label: 'Retiring in next 5 years', icon: Clock },
    { stat: '2-3 yrs', label: 'Time for new hire proficiency', icon: TrendingUp },
    { stat: '0%', label: 'Chance you\'re getting more staff', icon: AlertTriangle }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 via-orange-50 to-red-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 border border-amber-300 text-amber-800 font-medium rounded-full mb-6">
              <AlertTriangle className="w-5 h-5" />
              <span>The Uncomfortable Truth</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Half Your Acquisition Workforce Is{' '}
              <span className="text-red-600">Retiring</span>.
              <br />Are You Ready?
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              You&apos;re not getting more people. The hiring pipeline can&apos;t keep up. 
              And the institutional knowledge walking out the door? It&apos;s not coming back.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              <strong>But what if your current team could do 4x the work?</strong>
            </p>
            <div className="bg-white rounded-xl p-6 shadow-lg border border-amber-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Brain className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">AcuSightPro captures institutional knowledge</h4>
                  <p className="text-gray-600 text-sm">
                    Every decision, every evaluation, every lesson learned, captured in the system. 
                    When your senior COs retire, their expertise stays.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {crisisStats.map((item, index) => (
              <div
                key={index}
                className={`rounded-2xl p-6 ${
                  index === 3 
                    ? 'bg-red-600 text-white' 
                    : 'bg-white border border-gray-200 shadow-sm'
                }`}
              >
                <item.icon className={`w-8 h-8 mb-3 ${index === 3 ? 'text-red-200' : 'text-amber-600'}`} />
                <div className={`text-4xl font-bold mb-2 ${index === 3 ? 'text-white' : 'text-gray-900'}`}>
                  {item.stat}
                </div>
                <div className={`text-sm ${index === 3 ? 'text-red-100' : 'text-gray-600'}`}>
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StaffingCrisis;
